(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/campaign-card.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/campaign-card.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  campaign: {
    openCampaignApi
  },
  productMapping
} = svs.numbergames;
svs.numbergames.game.views.CampaignCard = Marionette.View.extend({
  regions: {
    campaignChances: '.campaign-chances-region'
  },
  ui: {
    campaignCard: '.ng-campaign-card'
  },
  triggers: {
    'click @ui.campaignCard': 'campaignCardClicked'
  },
  getTemplate() {
    return this.campaignData ? svs.numbergames.campaign_ui.templates.campaign_card : false;
  },
  templateContext() {
    return _objectSpread(_objectSpread({}, this.campaignData), {}, {
      product: this.model.get('productId'),
      chancesClassName: 'campaign-chances-region'
    });
  },
  initialize() {
    this.campaignData = openCampaignApi.getCampaign(this.model.get('productId'));
  },
  onRender() {
    new svs.ui.ExpandableCard({
      el: this.el
    });
    this.showChildView('campaignChances', new Marionette.View({
      tagName: 'p',
      model: this.model,
      collection: this.model.get('boards'),
      collectionEvents: {
        'change:hasKungKeno': 'render'
      },
      modelEvents: {
        'change:price': 'render'
      },
      template: () => {
        const wager = this.model.toObject();
        const draws = svs.numbergames.game.draw.drawNumbers(this.model.get('selectedDays'));
        const numberOfChances = openCampaignApi.calculateChances(this.model.get('productId'), {
          wager,
          draws
        });
        return "".concat(numberOfChances, " ").concat(numberOfChances === 1 ? 'chans' : 'chanser');
      }
    }));
  },
  onCampaignCardClicked() {
    svs.components.analytics.trackEvent({
      category: 'campaign',
      action: 'campaign_card_click',
      opt_label: productMapping.getBrandingClass(this.model.get('productId'))
    });
  }
});

 })(window);